export class PassengerType {
  passengertypeId: string;
  passengerTitle: string;
  passengerDescription: string;
  passengerMinCount: number;
  passengerCount: number;
  passengerMaxCount: number;
  passengerToolTip: string;
  passengerSingular: string;
  passengerPlural: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['passengertypeId']) {
        this.passengertypeId = contentjson['passengertypeId'];
      }
      if (contentjson['passengerTitle']) {
        this.passengerTitle = contentjson['passengerTitle'];
      }
      if (contentjson['passengerDescription']) {
        this.passengerDescription = contentjson['passengerDescription'];
      }
      if (contentjson['passengerMinCount']) {
        this.passengerMinCount = contentjson['passengerMinCount'];
        this.passengerCount = contentjson['passengerMinCount'];
      }
      if (contentjson['passengerMaxCount']) {
        this.passengerMaxCount = contentjson['passengerMaxCount'];
      }
      if (contentjson['passengerToolTip']) {
        this.passengerToolTip = contentjson['passengerToolTip'];
      }
      if (contentjson['passengerSingular']) {
        this.passengerSingular = contentjson['passengerSingular'];
      }
      if (contentjson['passengerPlural']) {
        this.passengerPlural = contentjson['passengerPlural'];
      }
    }
  }
}
